import React, { useState, useEffect } from 'react';
import { Select, Button, Tooltip, Icon, DatePicker } from 'antd';

import Grid from '@material-ui/core/Grid';
import TextEvents from 'app/components/TextEvents';
import TextInput from 'app/components/TextInput';
// import FrontContainer from 'app/containers/FrontContainer';
import CommunicationProgramSummaryContainer from 'app/containers/CommunicationProgramSummaryContainer';
// import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import { useDispatch, useSelector } from 'react-redux';
// import CommunicationProgramContainer from 'app/containers/CommunicationProgramContainer';
import { EXPORT_CA_REQUEST, EXPORT_CA_SUCCESS, EXPORT_CA_FAILURE } from 'app/actions/CommunicationProgramActions';
// import { fetchCommunicationsDispatch, workCycleEvaluationClear } from 'app/actions/WorkCycleActions';
import { fetchCommunicationProgramSummary, clearCommunicationProgramSummary, fetchGraphics, clearGraphics } from 'app/actions/CommunicationProgramActions';

import ApiService from 'app/services/ApiService';

import moment from 'moment';

const { Option } = Select;



const SelectItem = (name = [], value) => {
    if (name == null) {
        return <Option disabled key={'cargando'}>Cargando valores..</Option>
    }

    let x = [...new Set(name.map(i => i[value]))];
    x = name.map(i => i[value]);
    return (
        x.map((c, i) => <Option key={i}>{c}</Option>)
    );
}
export default function ComplianceAdvanceForm(props) {
    const classes = props.classes;
    const dispatch = useDispatch();
    const [collapse, setCollapse] = useState(true);
    let [frontList, setFrontList] = useState();
    const [subdir, setSubdir] = useState('');
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');

    useEffect(() => {
        (search());
    }, [dispatch])

    const disabledMEndDate = (current) => {
        if (fechaInicio === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) < moment(fechaInicio)) {
                return true;
            } else return false;
        }
    }

    const {
        idSubdirection,
        employeeId
    } = useSelector(state => state.Auth.employeeById)

    const {
        isLoadingCAExport
    } = useSelector(state => state.CommunicationProgram);

    const isOilService = idSubdirection === 3;

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const {
        siteId
    } = useSelector(state => state.Auth);

    const detrmineRolSite = () => {
        //Regla 17.03.2022 Rivera: Si es admin abordo => tipo de capacitacion D.O; Admin Tierra => Sus tipos de capacitacion
        for (const rol of Roles) {
            if (rol.NameRole.includes('Administrador'))
                return siteId;
        }
        return '';
    }

    const data = {
        trainingId: props.training,
        CommunicationProgramId: props.cp,
        frontId: props.front,
        rolSite: !props.training.length ? detrmineRolSite() : '',
        employeeId: employeeId,
        limit: props.pagination.pageSize,
        offset: (0 * props.pagination.pageSize),
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === 'ascend' ? 'ASC' : 'DESC' : '',
        SubdirectionId: idSubdirection/*subdir*/
        , EsSuperAdmin: 0,
    }

    const search = async () => {
        var respnse = IsSuperAdmin();
        data.EsSuperAdmin = respnse ? 1 : 0
        dispatch(clearCommunicationProgramSummary());
        dispatch(clearGraphics());
        dispatch(fetchCommunicationProgramSummary(data));
        dispatch(fetchGraphics(data));
        props.setFormData(data)
    }



    const IsSuperAdmin = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Super Administrador')) {
                return true;
            }

        }
        return null;
    }

    const toExport = async () => {

        var respnse = IsSuperAdmin();
        const params = {
            idSubdirection: idSubdirection,
            frontId: props.front,
            idTraining: props.training,
            idCommunicationProgram: props.cp,
            rolSite: !props.training.length ? detrmineRolSite() : '',
            employeeId: employeeId,
            EsSuperAdmin: respnse ? 1 : 0,
        }
        dispatch({ type: EXPORT_CA_REQUEST });
        await ApiService.getCommunicationProgramsSummaryExport(params)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, 'CumplimientoDeAvance.xlsx');
                    dispatch({ type: EXPORT_CA_SUCCESS });
                },
                error => {
                    // eslint-disable-next-line no-throw-literal
                    dispatch({ type: EXPORT_CA_FAILURE });
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    // const findSubdir = (params, v) => {
    //     let values = [...new Set(v)];
    //     let temp = [];
    //     for (let i = 0; i < values.length; i++) {
    //         let id = params.filters.subdirection[values[i]].idSubdirection;
    //         params.filters.subdirection.forEach((v) => {
    //             if (v.idSubdirection === id) {
    //                 temp.push(v);
    //             }
    //         });
    //     }
    //     if (temp.length === 0) {
    //         setSubdir('')
    //     } else {
    //         setSubdir(String(temp[0].idSubdirection));
    //     }
    // }
    const findCP = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        const array = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.filters.communicationProgram[values[i]].idCommunicationProgram;
            params.filters.communicationProgram.forEach((v) => {
                if (v.idCommunicationProgram === id) {
                    temp.push(v);
                }
            });
        }
        if (temp.length === 0) {
            props.setCP([])
        } else {
            temp.map(i => {
                array.push(i.idCommunicationProgram)
            });
            props.setCP(array.join(','));
        }
    }

    const findTraining = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        const array = []
        for (let i = 0; i < values.length; i++) {
            let id = params.filters.training[values[i]].idTraining;
            params.filters.training.forEach((v) => {
                if (v.idTraining === id) {
                    temp.push(v);
                }
            });
        }
        if (temp.length === 0) {
            props.setTraining([])
        } else {
            temp.map(i => {
                array.push(i.idTraining)
            });
            props.setTraining(array.join(','));
        }
    }

    const handleChange = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        const array = []
        for (let i = 0; i < values.length; i++) {
            let id = params.filters.front[values[i]].idFront;
            params.filters.front.forEach((v) => {
                if (v.idFront === id) {
                    temp.push(v);
                }
            });
        }
        if (temp.length === 0) {
            props.setFront([])
        } else {
            temp.map(i => {
                array.push(i.idFront)
            });
            props.setFront(array.join(','))
        }

        // i.forEach(() => {
        //     if (key === 'frontName') {
        //         let newFrontList = [];
        //         array.map(i => {
        //             return frontList.map(ids => {
        //                 const res = ids['idFront'];
        //                 return ids.frontName === i ? newFrontList.push(res) : null
        //             })
        //         })
        //         props.setFront(String(newFrontList))
        //     }
        // })
        // // if (array.length === 0) {
        // //     dispatch(clearCommunicationProgramSummary())
        // //     dispatch(fetchCommunicationProgramSummary(data));
        // // }
    }
    return (
        <CommunicationProgramSummaryContainer subdirectionId={idSubdirection}>
            {(params) => {
                return (
                    <div>
                        <div hidden={collapse}>
                            <Grid container direction='row'>
                                <Grid item xs={6}>
                                    {/* <TextInput
                                        text='Subdirección'
                                        color='darker'
                                        size='label'
                                        weight='medium'
                                        placeholder='Selecciona subdirección'
                                        style={props.styles.inputSelect}
                                        allowClear={true}
                                        onChange={(v) => {
                                            findSubdir(params, v);
                                        }}
                                    >
                                        {SelectItem(params.filters.subdirection, 'subdirectionName')}
                                    </TextInput> */}
                                    <TextInput
                                        mode='multiple'
                                        text='Tipo de capacitación'
                                        color='darker'
                                        size='label'
                                        weight='medium'
                                        placeholder='Selecciona capacitacón'
                                        style={props.styles.inputSelect}
                                        allowClear={true}
                                        onChange={(v) => {
                                            findTraining(params, v);
                                        }}
                                    >
                                        {SelectItem(params.filters.training, 'trainingName')}
                                    </TextInput>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextInput
                                        mode='multiple'
                                        text='Programa de comunicación'
                                        color='darker'
                                        size='label'
                                        weight='medium'
                                        placeholder='Selecciona programa de comunicación'
                                        style={props.styles.inputSelect}
                                        allowClear={true}
                                        onChange={(v) => {
                                            findCP(params, v);
                                        }}
                                    >
                                        {SelectItem(params.filters.communicationProgram, 'communicationProgramName')}
                                    </TextInput>

                                </Grid>

                                {/* <Grid item xs={6}>
                                    <TextEvents
                                        text='Fecha Inicial:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <DatePicker
                                        style={props.styles.inputSelect}
                                        placeholder='Selecciona Fecha Inicial'
                                        format={'DD/MM/YYYY'}
                                        onChange={(date, dateString) => {
                                            setFechaInicio(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                        }}

                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextEvents
                                        text='Fecha Final:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <DatePicker
                                        style={props.styles.inputSelect}
                                        placeholder='Selecciona Fecha Final'
                                        disabledDate={disabledMEndDate}
                                        format={'DD/MM/YYYY'}
                                        onChange={(date, dateString) => {
                                            setFechaFin(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                        }}

                                    />
                                </Grid> */}
                            </Grid>

                            {isOilService ? (<Grid container direction='row'>
                                <Grid item xs={6}>
                                    <TextEvents
                                        text='Frente:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <Select
                                        mode="multiple"
                                        showSearch
                                        optionFilterProp="children"
                                        style={props.styles.inputSelect}
                                        placeholder="Selecciona el frente"
                                        onChange={(v, i) => handleChange(params, v)}
                                    >
                                        {SelectItem(params.filters.front, 'frontName')}
                                    </Select>
                                </Grid>

                            </Grid>) : null}

                        </div>
                        <div className={classes.container} style={props.styles.baseVerticalMargin}>
                            {
                                collapse ?
                                    <Tooltip title={"Mostrar filtro"}>
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="link"
                                            onClick={() => setCollapse(false)}
                                        >
                                            <Icon type="down" />
                                        </Button>
                                    </Tooltip> :
                                    <Tooltip title={"Ocultar filtro"}>
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="link"
                                            onClick={() => setCollapse(true)}
                                        >
                                            <Icon type="up" />
                                        </Button>
                                    </Tooltip>
                            }
                            <Button
                                className={classes.button}
                                variant='contained'
                                type='primary'
                                onClick={() => search(params)}
                            >
                                Buscar
                            </Button>
                            <Button
                                className={classes.button}
                                variant='contained'
                                type='primary'
                                onClick={toExport}
                                loading={isLoadingCAExport}
                            >
                                Exportar
                            </Button>
                        </div>
                    </div>
                )
            }}
        </CommunicationProgramSummaryContainer>
    );

}